import styled from 'styled-components';

const OptionTitle = styled.h4`
  font-family: ${Styles.fontFamily.base};
  line-height: 1.1;
  margin: 0;
  padding: 0;
  text-transform: ${Styles.textTransform.headlines};
`;

export default OptionTitle;
